

import React from 'react'
import Newnavbar from './Newnavbar'
import Newfooter from './Newfooter'
import banphone from '../Pages/Newimages/banner-phone.png';
import sidephone from '../Pages/Newimages/sidephone.png';
import aws from '../Pages/Newimages/aws.png';
import zoho from '../Pages/Newimages/zoho.png';
import surya from '../Pages/Newimages/surya.png';
import csb from '../Pages/Newimages/csb.png';
import digital from '../Pages/Newimages/digital.png';
import axis from '../Pages/Newimages/axis.png';
import open from '../Pages/Newimages/open.png';
import stat from '../Pages/Newimages/stat.png';
import time from '../Pages/Newimages/time.png';
import circle from '../Pages/Newimages/circle.png';
import thunder from '../Pages/Newimages/thunder.png';
import empowering from '../Pages/Newimages/empowering.png';
import lap from '../Pages/Newimages/laptop.png';
import playbtn from '../Pages/Newimages/playbtn.png';
import applebtn from '../Pages/Newimages/applebtn.png';
import newplaystore from '../Pages/Newimages/newplaystore.png';
import img1 from '../Images/careers/img1.png';
import img2 from '../Images/careers/img2.png';
import img3 from '../Images/careers/img3.png';
import img4 from '../Images/careers/img4.png';



const Careers = () => {


  const jobOpenings = [
  {
    title: "Business Development Executive",
    image: img1,
    email: "careers@paybi.in",
  },
  {
    title: "Data Analytics",
    image: img2,
    email: "careers@paybi.in",
  },
  {
    title: "Accountant",
    image: img3,
    email: "careers@paybi.in",
  },
  {
    title: "Business Analytics",
    image: img4,
    email: "careers@paybi.in",
  },
];

  const partnerLogos = [
    { name: "Axis Bank", query: "Axis Bank logo" },
    { name: "Zoho", query: "Zoho logo" },
    { name: "CSB Bank", query: "CSB Bank logo" },
    { name: "AWS", query: "AWS logo" },
    { name: "Suryoday Bank", query: "Suryoday Bank logo" },
    { name: "Generic Bank", query: "Generic bank logo" }, // Added to match visual density
  ]



  return (
    <div>
            <Newnavbar />
            <div className="min-h-screen bg-stone-50 flex flex-col">
              <main className="flex-grow py-12 md:py-20 px-4 sm:px-6 lg:px-8">
                <section className="text-center max-w-3xl mx-auto mb-12 md:mb-16 trust_below_des leading-relaxed">
                  <p className="!text-4xl md:!text-5xl !font-bold !text-gray-900 !mb-4 py-2">
                    Join the PayBi Team
                  </p>
                  <h6 className="md:!text-[18px] !text-[16px] font-medium !text-[#525252] leading-relaxed ">
                    At PayBi, we’re redefining how people and businesses manage their money. We’re building smart, secure, and intuitive fintech solutions—and we’re looking for passionate minds to join us on this journey.
                  </h6>
                </section>

                <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
                 {jobOpenings.map((job, index) => (
  <div key={index} className="rounded-xl shadow-md overflow-hidden bg-white">
    <div className="p-0">
      <img
        src={job.image}
        alt={job.title}
        className="w-full h-48 object-cover rounded-t-xl p-[12px]"
      />
      <div className="p-4 space-y-[14px]">
        <h3 className="!text-[#313130] text-[16px] font-medium text-center ">{job.title}</h3>
        <button
          className="w-full !rounded-[8px] !border !border-[#C4C4C4] text-black text-[14px] font-semibold hover:bg-[#e6e6e6] bg-transparent py-2"
        >
          Apply in {job.email}
        </button>
      </div>
    </div>
  </div>
))}
                </section>
              </main>

    </div>

    <div className="trust_companies !mx-auto !px-4 !py-8">
                <h2 className="!text-center md:!text-[32px] !text-[20px] !font-semibold !mb-6">
                    Trusted and Partnered with Leading Institutions
                </h2>
                {/* Desktop View */}
                <div className="!hidden md:!flex !space-x-6 !mx-auto !w-fit">
                    {[zoho, aws, axis, digital, csb, open, surya, open].map((src, i) => (
                        <img
                            key={i}
                            src={src}
                            alt="Partner Logo"
                            className="!w-[100px] !h-[100px] !object-contain"
                        />
                    ))}
                </div>
                {/* Mobile/Tablet Carousel */}
                <div className="!block md:!hidden !overflow-hidden !relative !w-full">
                    <div className="!flex !w-max !animate-scroll-left !space-x-6">
                        {[...Array(2)].flatMap(() =>
                            [zoho, aws, axis, digital, csb, open, surya, open].map((src, i) => (
                                <img
                                    key={`${src}-${i}`}
                                    src={src}
                                    alt="Partner Logo"
                                    className="!w-[100px] !h-[100px] !object-contain"
                                />
                            ))
                        )}
                    </div>
                </div>
            </div>
            <Newfooter />
      
    </div>
  )
}

export default Careers
